if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });


        const activeMedia = this.querySelectorAll(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

        activeMedia.forEach((element) => {
          const activeMediaTemplate = element.querySelector('template');
          const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;


          const selectedMedia = element.getAttribute('data-index') == this.openedBy.getAttribute('data-index') ? element : null;

          element.classList.add('active');

          if(selectedMedia) {
            selectedMedia.scrollIntoView();
          }

          const container = this.querySelector('[role="document"]');
          container.scrollLeft = (element.width - container.clientWidth) / 2;

          if (
            activeMedia.nodeName == 'DEFERRED-MEDIA' &&
            activeMediaContent &&
            activeMediaContent.querySelector('.js-youtube')
          )
            activeMedia.loadContent();
        });

      }
    }
  );
}
